import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL, // Base URL from the environment variable
});
console.log(process.env.REACT_APP_BASE_URL);
// Add a request interceptor to include accessToken if available
api.interceptors.request.use(
  async (config) => {
    const getToken = () => localStorage.getItem('token');
    const AccessToken = getToken();
    if (AccessToken) {
      config.headers['Authorization'] = `Bearer ${AccessToken}`; // Add accessToken if user is logged in
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;

